import { getMutations } from 'entities/_config';

import { apiCall, SuccessData } from 'services/api';

interface RedemptionProps {
  amount: number;

  // Add stricter typing here
  type: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

export const rewardMutations = getMutations({
  requestRedemption: {
    action: async ({ amount, type, ...data }: RedemptionProps): Promise<SuccessData> => {
      return apiCall({
        path: '/rewards/redemption/request',
        payload: {
          amount,
          type,
          data,
          // captchaToken: await getCaptchaToken(),
        },
      });
    },
  },
});
